import { render, staticRenderFns } from "./ProductBlockVideoElement.vue?vue&type=template&id=f767e78a"
import script from "./ProductBlockVideoElement.vue?vue&type=script&lang=js"
export * from "./ProductBlockVideoElement.vue?vue&type=script&lang=js"
import style0 from "./ProductBlockVideoElement.vue?vue&type=style&index=0&id=f767e78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports